import { App } from './app/app';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';

bootstrapApplication(App, appConfig)
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
